import type { Dispatch } from "react";
import type { EditorAction } from "../../editor/reducers";
import type { CaptionRegionTypeCardFragment } from "../../client/generated";
import { RegionTypeCard } from "../RegionTypeCard";
import { useTranslation } from "react-i18next";

type Props = {
  fragment: CaptionRegionTypeCardFragment;
  dispatch: Dispatch<EditorAction>;
};

export function CaptionRegionTypeCard({ fragment, dispatch }: Props) {
  const { t } = useTranslation();

  const onConvert = () => {
    dispatch({
      type: "switchToRegionTab",
      tab: "caption",
      regionId: fragment.id,
    });
  };

  return (
    <RegionTypeCard
      title={t("CaptionRegionTypeCard.title")}
      description={t("CaptionRegionTypeCard.description")}
      onConvert={onConvert}
    />
  );
}
